var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvironmentIconsStaging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 103.11,
    height: 90.204,
    viewBox: "0 0 103.11 90.204",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103.11,
    height: 90.204,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.99,45.643,64.878,29.533a4.836,4.836,0,0,0-8.249,3.42V41H50.185L39.556,29.616,28.815,41.13,43.024,56.342a2.4,2.4,0,0,0,1.767.768H56.629v8.058a4.836,4.836,0,0,0,8.249,3.418L80.989,52.479a4.832,4.832,0,0,0,0-6.834l0,0",
    transform: "translate(20.703 20.207)",
    fill: "#3a3630"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.416,23.6H19.333L29.962,34.991,40.7,23.477,26.494,8.265A2.4,2.4,0,0,0,24.727,7.5H2.416A2.417,2.417,0,0,0,0,9.908V21.185A2.415,2.415,0,0,0,2.414,23.6Z",
    transform: "translate(0 5.387)",
    fill: "#3a3630"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.332,28.989v8.053a4.836,4.836,0,0,0,8.249,3.418l16.111-16.107a4.833,4.833,0,0,0,0-6.834L85.581,1.409a4.836,4.836,0,0,0-8.249,3.418v8.051H65.494a2.4,2.4,0,0,0-1.767.768L19.333,61.211H2.416A2.416,2.416,0,0,0,0,63.627V74.9a2.415,2.415,0,0,0,2.414,2.418H24.727a2.418,2.418,0,0,0,1.767-.773L70.888,28.989Z",
    transform: "translate(0 0)",
    fill: "#e95252"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironmentIconsStaging);
export default __webpack_public_path__ + "static/media/environmentIcons_Staging.95672fcb.svg";
export { ForwardRef as ReactComponent };